import React from "react";
import { useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import "./ProductCard.css";
import { getOptimizedUrl } from "../../../../constants/globalFunction";
import { RUPEE } from "../../../../constants/globalConstants";

const ProductCard = ({ item, order_status, orderId, fromNotification }) => {
  const navigate = useNavigate();

  const imageSource = item?.image || undefined;
  const pricePerItem = item?.price;
  const totalPrice = item?.price * item?.qty;
  const ratingReview = item?.rating_review;

  const handleRatingClick = () => {
    navigate(`/rating-review`, {
      state: {
        productDetails: {
          name: item?.name,
          image: imageSource ? getOptimizedUrl(imageSource) : null,
        },
        orderProductId: item?._id,
        orderId: orderId,
        fromNotification: fromNotification,
      },
    });
  };

  return (
    <div className="product-card">
      <div className="product-card__content">
        <div className="product-card__image-container">
          {imageSource ? (
            <img
              src={getOptimizedUrl(imageSource)}
              alt={item?.name || "Product"}
              className="product-card__image"
              loading="lazy"
            />
          ) : (
            <div className="product-card__image-placeholder" />
          )}
        </div>
        <div className="product-card__details">
          <h4 className="product-card__name">{item?.name || "Product"}</h4>
          <div className="product-card__attributes">
            <span className="product-card__attribute">Size: {item?.size}</span>
            <span className="product-card__attribute">Qty: {item?.qty}</span>
            {item?.color && (
              <span className="product-card__attribute">
                Color: {item?.color}
              </span>
            )}
            {item?.fabric && (
              <span className="product-card__attribute">
                Fabric: {item?.fabric}
              </span>
            )}
            {item?.brand && (
              <span className="product-card__attribute">
                Brand: {item?.brand}
              </span>
            )}
          </div>
          <div className="product-card__price-row">
            {parseInt(item?.qty) > 1 && (
              <span className="product-card__price-per-item">
                {RUPEE}
                {pricePerItem}
              </span>
            )}
            <span className="product-card__price-total">
              {RUPEE}
              {totalPrice}
            </span>
          </div>
        </div>
      </div>

      {order_status === "delivered" && !ratingReview && (
        <div className="product-card__actions">
          <button
            className="product-card__rate-review-btn"
            onClick={handleRatingClick}
          >
            <FaStar className="product-card__rate-review-icon" />
            <span className="product-card__rate-review-text">
              Rate & Review Product
            </span>
          </button>
        </div>
      )}

      {ratingReview && (
        <div className="product-card__rating">
          {ratingReview?.rating > 0 && (
            <div className="product-card__stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                  key={star}
                  className={`product-card__star ${
                    star <= ratingReview?.rating
                      ? "product-card__star--filled"
                      : ""
                  }`}
                />
              ))}
            </div>
          )}
          {ratingReview?.review && (
            <p className="product-card__review">{ratingReview?.review}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductCard;
